import React from 'react';
import { Avatar as MuiAvatar } from '@mui/material';
import { cn } from '@/lib/utils';

/**
 * Tab Lịch Phỏng Vấn (`interviews`)
 * Hiển thị danh sách các buổi phỏng vấn sắp diễn ra và lịch theo dõi trực quan.
 */
export const RecruiterInterviewsTab: React.FC = () => {
  return (
    <div className="space-y-6 animate-fade-in text-left">
      <div className="border-b pb-5">
        <h1 className="font-display font-bold text-2xl text-gray-900 leading-tight">Lịch phỏng vấn</h1>
      </div>

      <div className="grid lg:grid-cols-3 gap-6">
        {/* Cột Bên Trái: Danh sách lịch phỏng vấn sắp tới */}
        <div className="lg:col-span-2 space-y-4">
          <h3 className="text-sm font-black text-gray-800 uppercase tracking-wider flex items-center gap-2">
            Lịch phỏng vấn sắp diễn ra
          </h3>

          {[
            {
              candidate: 'Trần Thị Minh Anh',
              position: 'UI/UX Designer',
              time: '14:00 - 15:00',
              date: '30/05/2026',
              type: 'Online (Google Meet)',
              status: 'sắp diễn ra',
              avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150',
            },
            {
              candidate: 'Nguyễn Hoàng Nam',
              position: 'Frontend Developer',
              time: '10:00 - 11:30',
              date: '02/06/2026',
              type: 'Trực tiếp tại văn phòng',
              status: 'chờ xác nhận',
              avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150',
            },
          ].map((int, i) => (
            <div key={i} className="bg-white rounded-2xl p-5 border border-gray-100 shadow-sm flex items-start gap-4 hover:shadow-md transition-shadow">
              <MuiAvatar src={int.avatar} sx={{ width: 48, height: 48, borderRadius: '12px' }} className="shrink-0" />
              <div className="flex-1 space-y-2">
                <div className="flex items-center justify-between">
                  <h4 className="font-bold text-gray-800">{int.candidate}</h4>
                  <span
                    className={cn(
                      "text-[10px] font-black px-2 py-0.5 rounded-full uppercase tracking-wider",
                      int.status === 'sắp diễn ra' ? "bg-blue-50 text-blue-600" : "bg-yellow-50 text-yellow-600"
                    )}
                  >
                    {int.status}
                  </span>
                </div>
                <p className="text-xs text-gray-500 font-semibold">{int.position}</p>

                <div className="flex flex-wrap gap-x-4 gap-y-1.5 text-xs text-gray-400 font-semibold border-t pt-2.5">
                  <span>⏰ {int.time} ({int.date})</span>
                  <span>📍 {int.type}</span>
                </div>

                <div className="flex gap-2 pt-2">
                  <button className="bg-[#f97316] text-white text-xs font-bold px-4 py-1.5 rounded-lg hover:bg-orange-600 transition-colors shadow">
                    Tham gia
                  </button>
                  <button className="border border-gray-200 text-gray-600 text-xs font-bold px-4 py-1.5 rounded-lg hover:bg-gray-50 transition-colors">
                    Hoãn/Hủy
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Cột Bên Phải: Lịch rút gọn tháng */}
        <div className="bg-white rounded-3xl border border-gray-100 p-5 shadow-sm space-y-4 h-fit">
          <h4 className="text-sm font-black text-gray-800">Tháng 5, 2026</h4>
          <div className="grid grid-cols-7 gap-1 text-center text-xs font-bold text-gray-400 mb-2">
            {['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'].map((d, i) => (
              <div key={i}>{d}</div>
            ))}
          </div>
          <div className="grid grid-cols-7 gap-1 font-semibold text-xs text-gray-700">
            {Array.from({ length: 31 }, (_, i) => {
              const day = i + 1;
              const hasEvent = day === 30;
              return (
                <div
                  key={i}
                  className={cn(
                    "py-2 rounded-xl flex items-center justify-center cursor-pointer hover:bg-gray-50 relative",
                    hasEvent && "bg-orange-50 text-[#f97316] font-black border border-orange-200"
                  )}
                >
                  {day}
                  {hasEvent && <span className="absolute bottom-1 w-1 h-1 bg-[#f97316] rounded-full" />}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecruiterInterviewsTab;
